<template>
  <div>
    <v-btn
      v-if="getArea"
      color="primary mt-1"
      medium
      absolute
      right
      fab
      @click="showDialog()"
    >
      <v-icon medium>{{
        action === "Add" ? "mdi-plus" : "mdi-border-color"
      }}</v-icon>
    </v-btn>
    <v-dialog v-if="getArea" v-model="active" persistent max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-img
              max-height="350"
              contain
              v-if="form.src"
              :src="form.src"
            ></v-img>
            <v-btn
              class="mt-5"
              :block="true"
              outlined
              color="#D1433F"
              @click="onPickFile"
            >
              Upload Thumbnail
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
            <input
              type="file"
              style="display: none"
              ref="fileInput"
              accept="image/*"
              @change="onFilePicked"
            />
            <v-text-field
              v-model="form.title"
              label="Title*"
              required
            ></v-text-field>
            <v-row class="px-2">
              <v-menu
                v-model="calendar"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.dated"
                    label="Date Published"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.dated"
                  @input="calendar = false"
                ></v-date-picker>
              </v-menu>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="action === 'Update'"
            color="error"
            text
            @click="deleteData()"
            >Delete</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="active = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" text @click="submit()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  props: {
    action: {
      type: String,
      required: true
    },
    mydata: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters("global", ["getArea"])
  },
  data: () => ({
    calendar: false,
    active: false,
    title: "",
    form: {
      src: null,
      file: null,
      title: "",
      dated: "",
      Id: null
    }
  }),
  methods: {
    moment,
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      this.form.file = event.target.files[0];
      let filename = this.form.file.name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!!");
      }
      this.form.src = URL.createObjectURL(this.form.file);
    },
    showDialog() {
      if (this.action === "Update") {
        this.title = "Update Album";
        this.form = {
          src: this.mydata.Image_Link,
          file: null,
          title: this.mydata.Title,
          dated: moment(String(this.mydata.Dated)).format("YYYY-MM-DD"),
          id: this.mydata.Id
        };
      } else {
        this.title = "Add New Album";
        this.form = {
          src: null,
          file: null,
          title: null,
          dated: "",
          id: null
        };
      }
      this.active = true;
    },
    async submit() {
      try {
        if (this.action === "Add") {
          await this.$emit("add", this.form);
        } else {
          await this.$emit("update", this.form);
        }
        this.active = false;
      } catch (error) {
        console.log(error);
      }

      this.active = false;
    },
    deleteData() {
      this.$emit("delete", this.form.id);
      this.active = false;
    }
  }
};
</script>